
{{#if showPattern}}
    {{t pattern}}
{{/if}}
